<div id="image-container">
  <div [innerHtml]="html?.before ?? '' | kwikuiSafeHtml"></div>
  <img
    [attr.alt]="altText"
    [attr.id]="id"
    [attr.loading]="loadingType"
    [attr.src]="safeImageSrc"
    [class]="class"
    [style]="styles"
    (click)="handleOnClick($event)"
  />
  <div [innerHtml]="html?.after ?? '' | kwikuiSafeHtml"></div>
</div>
